<script lang="ts">
  import type { Snippet } from 'svelte';

  // Bordered content panel. Used to group form fields, profile info,
  // settings sections — anything that needs visual containment without
  // being a full modal. `elevated` adds the brand shadow for surfaces
  // that should pop off the background (e.g. the auth-form card).

  interface Props {
    padding?: 'sm' | 'md' | 'lg';
    elevated?: boolean;
    children: Snippet;
  }

  let { padding = 'md', elevated = false, children }: Props = $props();
</script>

<div
  class="ui-card"
  class:ui-card--elevated={elevated}
  class:ui-card--pad-sm={padding === 'sm'}
  class:ui-card--pad-md={padding === 'md'}
  class:ui-card--pad-lg={padding === 'lg'}
>
  {@render children()}
</div>
